import React from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';
import SearchBar from 'js/header/SearchBar/SearchBar';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

const CellRoot = styled.div<{ dividerTint: 'white' | 'beige' }>`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 16px;

  &.dividerTint-white {
    border-right: 1px solid var(--stroke-light, #dddde2);
  }

  &.dividerTint-beige {
    border-right: 1px solid var(--stroke-beige-light, #ccc9bc);
  }
`;

const CellWatcher = styled(ImpressionWatcher)`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  column-gap: 8px;
`;

const SearchGlyph = styled(Icon)`
  flex: 0 0 auto;
  color: var(--text-primary, #141413);
`;

const BarWrap = styled.div`
  flex: 1 1 auto;
  min-width: 0;

  & > div {
    margin-right: 0;
  }

  & > div > :global(.material-symbols-outlined) {
    display: none;
  }

  & textarea {
    padding-left: 0;
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  & textarea::placeholder {
    color: var(--text-placeholder, #6d6d7d);
  }
`;

export type SearchCellProps = {
  initialQuery?: string;
  isPremium?: boolean;
  dividerTint: 'white' | 'beige';
};

const SearchCell = ({
  initialQuery,
  isPremium = false,
  dividerTint,
}: SearchCellProps) => (
  <CellRoot dividerTint={dividerTint} data-testid="search-cell">
    <CellWatcher source="focused_nav_search_bar">
      <SearchGlyph name="search" size={32} aria-hidden />
      <BarWrap>
        <SearchBar
          initialQuery={initialQuery}
          isPremium={isPremium}
          placeholder="Search..."
        />
      </BarWrap>
    </CellWatcher>
  </CellRoot>
);

export default SearchCell;
